export function GuideService(context) {
	function _turnTo(name, params = {}) {
		context.$router.push({
			name,
			params
		});
	}
	return {
		turnToUseGuide(params) {
			_turnTo('UseGuide', params);
		}
	};
}

export function install(Vue, context) {
	Vue.prototype.$GuideService = GuideService(context);
}
